import { styled as o } from "@lokalise/styled";
import { value as r } from "../../utils/theme/index.js";
const d = o.img`
	display: block;
	position: relative;
	border-radius: ${r("radius.rounded")};
	width: ${({ $size: i }) => i}px;
	height: ${({ $size: i }) => i}px;
`;
export {
  d as Image
};
//# sourceMappingURL=styles.js.map
